import { render, staticRenderFns } from "./ProzessEntityFieldSelector.vue?vue&type=template&id=5de10556"
import script from "./ProzessEntityFieldSelector.vue?vue&type=script&lang=js"
export * from "./ProzessEntityFieldSelector.vue?vue&type=script&lang=js"
import style0 from "./ProzessEntityFieldSelector.vue?vue&type=style&index=0&id=5de10556&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports